import React, { useEffect, useState } from 'react';
import { Row, Col, Table  } from "react-bootstrap";
import { toast } from 'react-toastify';
import Select from 'react-select';

import CustomModal from "../../components/Modal/CustomModal";

import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultaEstBecados, AddEstBecado, ConsultEstBecadoInd } from "../../funciones/BecasFunction";
import EstBecadosDetail from './EstBecadosDetail';

const EstBecados = (props) => {
    const [cantEst, setCantEst] = useState(<i className="fa fa-spinner fa-spin"></i>);
    const [tipoBecaSelect, setTipoBecaSelect] = useState({ value: "2", label: "MEDIA BECA" });
    const [tipoBeca, setTipoBeca] = useState([
        { value: "2", label: "MEDIA BECA" },
        { value: "1", label: "BECA COMPLETA" },
        { value: "3", label: "BECA TRABAJO" }
    ]);
    const [estudiantes, setEstudiantes] = useState([]);
    const [preloader, setPreloader] = useState({ icono: "fa fa-spinner fa-spin", texto: "Buscando Estudiantes" });
    const [ci, setCi] = useState("");
    const [uc, setUc] = useState("");
    const [text, setText] = useState(<div><strong>INGRESA UNA CEDULA</strong></div>);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        ConsultaEstBecados((resp) => {
            setEstudiantes(resp);
            setCantEst(resp.length);
            if (resp.length === 0) setPreloader({ icono: "fa fa-times", texto: "No existen estudiantes registrados en la lista de becados" });
        })
    }, [props]);

    let cambiaTipo = (tipoBecaSelect) => {
        setTipoBecaSelect(tipoBecaSelect)
    }

    let consultaEstBecadoInd = () => {
        if (ci === "") return null;
        setText(<div><strong><i className="fa fa-spinner fa-spin"></i> Espera...</strong></div>);
        setDisabled(true);

        ConsultEstBecadoInd (ci, (resp) => {
            setDisabled(false);
            setText(<span className = 'text-danger'><strong>{resp.est}</strong> - (U.C. Inscritas: {resp.cantUc})</span>)
        })
    }

    let addEst = () => {
        switch (true){
            case (ci === ""):
                toast.error("Debes seleccionar la Cédula de Identidad", {autoClose: 4000});
            break;
            case (uc === ""):
                toast.error("Debes seleccionar la cantidad de Unidades de Crédito", {autoClose: 4000});
            break;
            default:
                AddEstBecado(ci, uc, tipoBecaSelect.value, (resp) => {
                    if (resp.status === "Error"){
                        toast.error(resp.mess, {autoClose: 4000});
                    }else{
                        setEstudiantes(resp.data);
                        setCantEst(resp.data.length);
                        if (resp.data.length === 0) setPreloader({ icono: "fa fa-times", texto: "No existen estudiantes registrados en la lista de becados" });
                    }

                    setCi("");
                    setUc("");
                    setText(<div><strong>INGRESA UNA CEDULA</strong></div>);
                })
            break;
        }
    }

    let contenido = () => {
        const styles = {
            padding: 5, fontSize: 12
        }

        let becasEst = () => {
            if (estudiantes.length === 0) return (
                <tr>
                    <td colSpan={5} align="center" className="text-danger"><i className={preloader.icono}></i> {preloader.texto}</td>
                </tr>
            )

            let num = 0;
            return estudiantes.map(option => {
                num++;
                return (
                    <EstBecadosDetail key = {option.id} num = {num} data = {option}/>
                )
            })
        }

        return (
            <React.Fragment>
                <div className="custom-alert-warning" style={{padding: 5}}>
                    <div><i className="fa fa-clone"></i> Estudiantes Becados <strong>({cantEst})</strong></div>
                </div>
                <div className="custom-alert-info" style={{marginTop: 5, paddingBottom: 6}}>
                    <Row>
                        <Col md = {5}><h6>Registro de Nuevos Becados</h6></Col>
                        <Col md = {7} align = "right"><h6>{text}</h6></Col>
                        <Col md = {4}>
                            <span style = {{fontSize: 10}}>Cédula del Estudiante</span>
                            <input className = "form-control" disabled = {disabled} onBlur = {consultaEstBecadoInd} value = {ci} onChange = {(e) => {setCi(e.target.value)}} type = "number" placeholder='Ej. 00000000'/>
                        </Col>
                        <Col md = {2}>
                            <span style = {{fontSize: 10}}>U.C</span>
                            <input className = "form-control" disabled = {disabled} value = {uc} onChange = {(e) => {setUc(e.target.value)}} type = "number" placeholder='Ej. V00000000'/>
                        </Col>
                        <Col md = {3}>
                            <span style = {{fontSize: 10}}>Tipo de Beca</span>
                            <Select
                                isDisabled = {disabled}
                                isSearchable = {true}
                                value={tipoBecaSelect}
                                onChange={cambiaTipo}
                                options={tipoBeca}
                            />
                        </Col>
                        <Col md = {3} style = {{paddingTop: 10}} align = "right">
                            <button disabled = {disabled} className="btn btn-primary" onClick = {addEst} style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar</button>
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF"/* , overflowX:"hidden", overflowY: "auto", maxHeight: 200 */}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color-warning">
                                    <td colSpan = {2} width="50%" style={styles}><strong>Estudiante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="15%" style={styles}><strong>Tipo</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {becasEst()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    let ayuda = () => {

    }

    return (
        <React.Fragment>
            <div className="content">
                <Row>
                    <Col md={8}>
                        {contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Estudiantes Becados</span>}
                                color="#a80012"
                                content={ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default EstBecados;


// WEBPACK FOOTER //
// ./src/views/Bienestar/EstBecados.jsx